import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ClauseLibraryState } from './state';

export const ClauseLibraryFeature = 'ClauseLibraryFeature';

export const ClauseLibraryFeatureStateSelector =
  createFeatureSelector<ClauseLibraryState>(ClauseLibraryFeature);

export const selectClauses = createSelector(
  ClauseLibraryFeatureStateSelector,
  (state: ClauseLibraryState) => state.clauses,
);

export const selectClausesLoading = createSelector(
  ClauseLibraryFeatureStateSelector,
  (state: ClauseLibraryState) => state.loadingClauses,
);

export const selectClauseCreating = createSelector(
  ClauseLibraryFeatureStateSelector,
  (state: ClauseLibraryState) => state.creatingClause,
);

export const selectCloseCreatingClauseModal = createSelector(
  ClauseLibraryFeatureStateSelector,
  (state: ClauseLibraryState) => state.closeCreatingClauseModal,
);

export const selectClauseLoading = createSelector(
  ClauseLibraryFeatureStateSelector,
  (state: ClauseLibraryState) => state.loadingClause,
);

export const selectClause = createSelector(
  ClauseLibraryFeatureStateSelector,
  (state: ClauseLibraryState) => state.clause,
);

export const selectClauseEditing = createSelector(
  ClauseLibraryFeatureStateSelector,
  (state: ClauseLibraryState) => state.editingClause,
);

export const selectCloseEditingClauseModal = createSelector(
  ClauseLibraryFeatureStateSelector,
  (state: ClauseLibraryState) => state.closeEditingClauseModal,
);

export const fromClauseLibrary = {
  selectClauses,
  selectClausesLoading,
  selectCloseCreatingClauseModal,
  selectClauseCreating,
  selectClause,
  selectClauseLoading,
  selectClauseEditing,
  selectCloseEditingClauseModal,
};
